module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Flyer_Poster-4be34a04f24b062e44640426e5adbee7.jpg";